import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { ManagementRefundRequestTop } from "@/components/features/management/refund-request/top/ui/components";

import { useConfirmParams } from "./hooks";

export const ManagementRefundRequestTopPage = () => {
	const result = useConfirmParams();

	const { canRender } = result;
	if (!canRender) return <></>;

	const { hotelID } = result;

	return (
		<PageMeta title="返金処理の一覧" url={generatePath(PATHS.HOTEL.MANAGEMENT.REFUND_REQUEST.TOP, { hotelID })}>
			<ManagementRefundRequestTop hotelID={hotelID} />
		</PageMeta>
	);
};

ManagementRefundRequestTopPage.displayName = "ManagementRefundRequestTopPage";
